module.exports = __webpack_public_path__ + "img/27.5de2c272.jpg";